'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM6.5 9L10 5.5 13.5 9H11v4H9V9H6.5zm11 6L14 18.5 10.5 15H13v-4h2v4h2.5z' });

var SwapVerticalCircle = function SwapVerticalCircle(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

SwapVerticalCircle = (0, _pure2.default)(SwapVerticalCircle);
SwapVerticalCircle.muiName = 'SvgIcon';

exports.default = SwapVerticalCircle;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/SwapVerticalCircle.js
// module id = 2913
// module chunks = 0